<div class="text-bg-highlight text-xlarge bg-red mb-3">
  {{ oversiktRow.name ? oversiktRow.name : "" }}
</div>

<form [formGroup]="form">
  <div class="d-flex flex-column mb-3">
    <label for="atgard">Åtgärd</label>
    <p-select
      id="atgard"
      formControlName="selectedAtgard"
      styleClass="w-100"
      [options]="atgarder"
      optionLabel="label"
      optionValue="value"
      placeholder="-"
    >
    </p-select>
  </div>

  <div *ngIf="selectedAtgard === Atgard.Synonymisera && oversiktRow.selectedField === nameType.Smittamne">
    <p class="radio-title">Typ av fynd</p>
    <div class="radio-group">
      <input
        type="radio"
        name="fyndType"
        id="positiv"
        [(ngModel)]="typeOfFynd"
        [value]="nameType.Smittamne"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="setTypeOfFynd(nameType.Smittamne)"
      />
      <label class="me-4 radio-label" for="positiv">Positiv</label>
      <input
        type="radio"
        name="fyndType"
        id="negativ"
        [(ngModel)]="typeOfFynd"
        [value]="nameType.NegativtFynd"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="setTypeOfFynd(nameType.NegativtFynd)"
      />
      <label class="me-4 radio-label" for="negativ">Negativ</label>
      <input
        type="radio"
        name="fyndType"
        id="beskrivande"
        [(ngModel)]="typeOfFynd"
        [value]="nameType.BeskrivandeFynd"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="setTypeOfFynd(nameType.BeskrivandeFynd)"
      />
      <label class="me-4 radio-label" for="beskrivande">Beskrivande</label>
    </div>
  </div>

  <div class="d-flex flex-column mb-3" *ngIf="form.controls['selectedAtgard'].value === Atgard.Synonymisera">
    <label for="synonymiseraTill">Spara som synonym till</label>
    <p-select
      id="synonymiseraTill"
      formControlName="synonymiseraTill"
      styleClass="w-100"
      [filter]="true"
      [showClear]="!loading"
      [options]="standardNamnLista"
      optionLabel="standardNamn"
      optionValue="standardNamn"
      placeholder="-"
      [readonly]="loading"
    >
    </p-select>
  </div>

  <div formGroupName="standardnamn" *ngIf="form.controls['selectedAtgard'].value === Atgard.NyttStandardnamn">
    <div class="d-flex flex-column mb-3" *ngIf="useShortName()">
      <label for="shortName">Kort namn</label>
      <input id="shortName" formControlName="shortName" type="text" pInputText />
    </div>
    <div class="d-flex flex-column mb-3">
      <label for="nyttnamn">Fullständigt namn <span class="text-danger">*</span></label>
      <input id="nyttnamn" formControlName="nyttnamn" type="text" pInputText />
      <p *ngIf="standardnamnInvalidLength()" class="text-danger">* Standardnamn måste vara mellan 3 och 100 tecken långa</p>
      <p *ngIf="atgardResult?.result === 'error'" class="text-danger">* {{atgardResult?.message}}</p>
    </div>
    <div class="d-flex flex-column mb-3" *ngIf="useID()">
      <label for="standardnameid">TaxID</label>
      <input id="standardnameid" formControlName="standardnameid" type="text" pInputText />
    </div>
    <div class="d-flex flex-column mb-3">
      <label for="standardNamnCoupling">Koppling till FOHM standardnamn</label>
      <p-select
        id="standardNamnCoupling"
        formControlName="standardNamnCoupling"
        styleClass="w-100"
        [options]="standardNamnLista"
        optionLabel="standardNamn"
        placeholder="-- Välj --"
        [showClear]="true"
      >
      </p-select>
    </div>
  </div>

  <div class="d-flex flex-column mb-3" *ngIf="useComments()">
    <label for="comment">Kommentar</label>
    <textarea id="comment" formControlName="comment" type="text" rows="3" pInputTextarea></textarea>
  </div>
</form>
<div class="d-flex mt-4" *ngIf="!loading">
  <p-button
    label="Avbryt"
    class="flex-grow-1 me-3"
    styleClass="w-100"
    severity="secondary"
    (click)="close()"
  ></p-button>
  <p-button
    label="Spara"
    class="flex-grow-1"
    styleClass="w-100"
    (click)="save()"
    [disabled]="form.pristine || !form.valid || loading || canSaveNewStandardNamn()"
  ></p-button>
</div>
<div class="d-flex flex-column align-items-center" *ngIf="loading">
  <p>{{ loadingText }}</p>
  <p-progressSpinner></p-progressSpinner>
</div>
